import { Flex, xcss } from '@atlaskit/primitives';

import { useGetSelectedCodingAgentAvatarsFromSearchParams } from '../../../controllers';
import { BoardColumnsSvg } from '../../assets/board-columns-svg';
import { ProjectSvg, Injections } from '../../assets/project-svg';

import { HeaderArrow } from './header-arrow';

export const RightHandSidePageProjectDetails = ({
	projectName,
}: {
	projectName: string | undefined;
}) => {
	const assignedAgents = useGetSelectedCodingAgentAvatarsFromSearchParams();
	const injections: Injections = {
		additionalObject: HeaderArrow,
		svgBody: BoardColumnsSvg({
			columnNames: ['TO DO', 'IN PROGRESS', 'DONE'],
			assignedAgents,
		}),
	};

	return (
		<Flex alignItems="center" justifyContent="center" xcss={containerStyles}>
			<ProjectSvg projectName={projectName} activeView="board" injections={injections} />
		</Flex>
	);
};

const containerStyles = xcss({
	height: '100%',
	backgroundColor: 'elevation.surface',
});
